<template>
    <div class="profile">
        <div class="profile__header">
            <div class="profile__list" v-if="this.subProfilesList && this.subProfilesList.length">
                <button 
                    v-for="item in subProfilesList"
                    class="profile__list-item"  
                    :class="{ 'active': selectedSubProfile === item._id }" 
                    :key="item._id" 
                    @click="selectSubProfile(item._id)"
                >
                    {{ item.name }}
                </button>
            </div>

            <div class="profile__adding" @click="addChild">
                <IconAdd class="profile__adding-icon"></IconAdd>
                <span class="profile__adding-text">Dodaj profil dziecka</span>
            </div>
        </div>

        <ProfileAvatarList v-if="isAvatarList" @closeModal="closeModal"></ProfileAvatarList>
        <LoginPIN v-if="isModalPin" @modalPinToggle="modalPinToggle"></LoginPIN>
        <ModalConsent v-if="isModalConsent" @consentHandle="consentHandle"></ModalConsent>
    </div>
</template>

<script>

import axios from "axios";
import IconAdd from "../elements/icons/IconAdd.vue";
import ProfileAvatarList from "../profile/ProfileAvatarList.vue";
import LoginPIN from "../login/LoginPIN.vue";
import ModalConsent from "../modals/ModalConsent.vue";
import { useToast } from "vue-toastification";
const toast = useToast()

export default {
    name: "AccountProfileHeader",
    components: {
        IconAdd,
        ProfileAvatarList,
        LoginPIN,
        ModalConsent
    },
    props: {
        subProfilesList: {
            type: Array
        },
        selectedSubProfile: {
            type: String
        }
    },    
    data() {
        return {
            CONSENT_ALLOW: '/api/krainaabc/account/user-application-data/consent-allow?device=www',
            isAvatarList: false,
            isModalPin: false,
            isModalConsent: false
        };
    },
    computed: {
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        }
    },    
    methods: {
        addChild() {
            if(this.globalUserData && !this.globalUserData.subprofile_process_consent) {
                this.isModalConsent = true;
            } else if (this.globalUserData && this.globalUserData.has_pin === false) {
                this.isModalPin = true;
            } else {
                this.isAvatarList = true;
            }

            this.$store.dispatch("changeModalBackdrop", true);
        },
        closeModal() {
            this.isAvatarList = false;
            this.$store.dispatch("changeModalBackdrop", false);
        },
        selectSubProfile(id) {
            this.$emit("selectSubProfile", id);
        },
        modalPinToggle(pin) {
            this.isModalPin = false;
            if(pin) {
                this.isAvatarList = true;
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        consentHandle(value) {
            this.isModalConsent = false;

            if(value) {
                this.saveConsentAllow();

                if(this.globalUserData && this.globalUserData.has_pin === false) {
                    this.isModalPin = true;
                } else {
                    this.isAvatarList = true;
                }
            }  else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        saveConsentAllow() {
            axios
                .post(this.CONSENT_ALLOW)
                .then((response) => {
                    if(response.data.data.success) {
                        toast.success("Zgody zostały zapisane"); 
                        this.$store.dispatch('globalUserData');
                    } else {
                        toast.error("Nie udało się zapisać zgód");
                    }
                })
                .catch(() => {
                    toast.error("Nie udało się zapisać zgód");
                }); 
        }              
    }
};
</script>